'use client';

import {
  ButtonGroup as HeroButtonGroup,
  Button as HeroButton,
} from '@heroui/react';
import { ReactNode } from 'react';

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outline'
  | 'ghost'
  | 'danger';

export interface ButtonGroupItem {
  id: string;
  label?: string;
  icon?: ReactNode;
  onPress?: () => void;
  variant?: ButtonVariant;
  isLoading?: boolean;
  isDisabled?: boolean;
  isIconOnly?: boolean;
  'aria-label'?: string;
}

export interface ButtonGroupProps {
  items: ButtonGroupItem[];
  variant?: ButtonVariant;
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  isDisabled?: boolean;
  orientation?: 'horizontal' | 'vertical';
}

export const ButtonGroup = ({
  items,
  variant = 'secondary',
  size = 'md',
  fullWidth,
  isDisabled,
  orientation = 'horizontal',
}: ButtonGroupProps) => {
  if (!items) return null;

  return (
    <HeroButtonGroup
      variant={variant as any}
      size={size}
      fullWidth={fullWidth}
      isDisabled={isDisabled}
      orientation={orientation}
    >
      {items.map((item, index) => (
        <HeroButton
          key={item.id}
          variant={item.variant as any}
          onPress={item.onPress}
          isPending={item.isLoading}
          isDisabled={item.isDisabled || isDisabled}
          isIconOnly={item.isIconOnly ?? !item.label}
          aria-label={item['aria-label']}
        >
          {index > 0 && <HeroButtonGroup.Separator />}
          {item.icon}
          {item.label}
        </HeroButton>
      ))}
    </HeroButtonGroup>
  );
};
